import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubSourcesSourcesHeaderCls: string;
			heHubSourcesSourcesItemCls: string;
		}
	},

	slug: string
}

class Sources extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Sources Sources Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesSourcesHeaderCls || '', 'he_hub_sources_sources', { animCls: 'animate__flipInX', once: true});
		if(this.publicVars.cssId.anim?.heHubSourcesSourcesItemCls) {
			const sourcesItemsCount = document.querySelectorAll(this.publicVars.cssId.anim?.heHubSourcesSourcesItemCls).length;

			for(let i = 1; i <= sourcesItemsCount; i++) {
				scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesSourcesItemCls + i, 'he_hub_sources_sources', { animCls: 'animate__fadeIn', once: true});
			}
		}
	}

	bind() {
		this.msg('bind');
	}
}

export default Sources;